import { z } from "zod";

export const PhoneNumber = z
  .object({
    phoneCode: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    phonePrefix: z.string(),
  })
  .passthrough();

export type PhoneNumber = z.infer<typeof PhoneNumber>;
